module.exports = __webpack_public_path__ + "static/media/realtime_logo.d66f9ec8.jpg";